(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsQueueController', TabActionsQueueController);

    TabActionsQueueController.$inject = ['$stateParams', '$state', 'TabActionsQueue', 'ParseLinks', 'AlertService', 'TabActionsQueueRetry', 'pagingParams', 'paginationConstants', '$rootScope'];

    function TabActionsQueueController($stateParams, $state, TabActionsQueue, ParseLinks, AlertService, TabActionsQueueRetry, pagingParams, paginationConstants, $rootScope) {
        var vm = this;
        vm.tabActionsQueues = [];
        //vm.predicates = {'insertDateTime': false};
        //vm.page = 0;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.charToSearch = pagingParams.search;
        vm.transition = transition;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.tabActionQueueGroups = [];
        vm.repeatable = pagingParams.repeatable;
        vm.currentState = "tab-action-queue";
        vm.licence = $rootScope.licence;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function () {

            var data = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                repeatable: vm.repeatable,
                query: vm.charToSearch,
                sort: sort()
            };

            TabActionsQueue.query(data, onSuccess, onError);

            function onSuccess(data, headers) {

                vm.tabActionsQueues = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;

                if(data.length > 0) {
                    if (vm.tabActionQueueGroups.length === 0) {
                        TabActionsQueue.getGroups({}, succ, err);
                    }
                    if ($stateParams.group !== null) {
                        vm.obj = $stateParams.group;
                        vm.selectObject($stateParams.group);
                    } else {
                        for (var i = 0; i < data.length; i++) {
                            vm.tabActionsQueues.push(data[i]);
                        }
                        if ($state.params.filter) {
                            vm.searchText = $state.params.filter;
                        }
                        if (vm.page === 0 && vm.page < vm.links['last']) {
                            vm.loadPage();
                        }
                    }
                }
                function succ(data, headers) {
                    vm.tabActionQueueGroups = data;
                    vm.tabActionQueueGroups.push("All");
                }
                function err(error) {
                    AlertService.error(error.data.message);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            data.query = vm.charToSearch;
        };
        vm.reset = function () {
            vm.page = 0;
            vm.tabActionsQueues = [];
            var orderCall = vm.loadAll();
        };

        vm.loadAll();

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();

        vm.retry = function (tabActionsQueue) {
            TabActionsQueueRetry.update({}, tabActionsQueue, onSuccess, onError);

            function onSuccess(data, headers) {
                tabActionsQueue = data;
                var i = vm.tabActionsQueues.findIndex(function (el) {
                    return el.id === tabActionsQueue.id;
                });
                if (i !== -1) {
                    vm.tabActionsQueues[i] = tabActionsQueue;
                }

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.selectObject = function (obj) {
            vm.tabActionsQueues = [];
            if (obj === "All" || obj === null || obj === undefined) {
                $stateParams.group = null;
                vm.reset();
            } else {
                TabActionsQueue.getByAlias({group: obj,  repeatable: vm.repeatable, sort: sort()}, onSuccess, onError);
            }


            function onSuccess(data, headers) {
                for (var i = 0; i < data.length; i++) {
                    vm.tabActionsQueues.push(data[i]);
                }
                    $stateParams.group = obj;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
    }
})();
